import { translate } from '@/app/i18n';
import { Flex, Text } from '@/app/ui/atoms';
import DashboardHelpCard from '@/app/ui/organisms/DashboardHelp/DashboardHelpCard';

const DashboardHelp = () => (
  <Flex.Container flexDirection="column" gap="3rem">
    <Text.SectionTitle>{translate('DASHBOARD.HELP_TITLE')}</Text.SectionTitle>
    <Flex.Container>
      <Text.LabelMedium>{translate('DASHBOARD.HELP_SUBTITLE')}</Text.LabelMedium>
    </Flex.Container>
    <Flex.Container gap="2rem">
      <DashboardHelpCard
        title={translate('DASHBOARD.HELP_CARD_1_QUESTION')}
        text={translate('DASHBOARD.HELP_CARD_1_ANSWER')}
      />
      <DashboardHelpCard
        title={translate('DASHBOARD.HELP_CARD_2_QUESTION')}
        text={translate('DASHBOARD.HELP_CARD_2_ANSWER')}
      />
      <DashboardHelpCard
        title={translate('DASHBOARD.HELP_CARD_3_QUESTION')}
        text={translate('DASHBOARD.HELP_CARD_3_ANSWER')}
      />
    </Flex.Container>
  </Flex.Container>
);

export default DashboardHelp;
